export default {
    namespaced: true,
    state() {
        return {
            recipes: [],
            total: 0,
            pageSize: 18,
        }
    },
    getters: {
        recipes: state => {
            return state.recipes
        },
        total: state => {
            return state.total
        },
        pageSize: state => {
            return state.pageSize
        },
    },
    mutations: {
        setRecipes: function(state , payload) {
            state.recipes = payload
        },
        setTotal: function(state , payload) {
            state.total = payload
        },
        setPageSize: function(state , payload) {
            state.pageSize = payload
        },
    },
    actions: {
        
    }
};